"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemCodePageContentGrasshopper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const purchases_1 = require("@completeanatomy/purchases");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const redeem_code_svg_1 = __importDefault(require("../../assets/images/redeem-code.svg"));
const PrimaryButton_1 = require("../../atoms/PrimaryButton/PrimaryButton");
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const Title_1 = require("../../atoms/Title/Title");
const RedeemCode_1 = require("../RedeemCode/RedeemCode");
function RedeemCodePageContentGrasshopper() {
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const { code, onCodeChange, canRedeem, isLoading, error, redeem, popover, isSuccess, } = (0, purchases_1.useRedeemCode)();
    (0, react_1.useEffect)(() => {
        if (isSuccess) {
            const redirectUrl = sessionStorage.getItem('nextUrl') || '/';
            window.location.href = window.location.origin + redirectUrl;
        }
    }, [isSuccess]);
    const onClickSignOut = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.logout();
    };
    /**
     * Opens external support hub site
     */
    const onNeedAssistanceClick = () => {
        const supportHubLink = 'https://service.elsevier.com/app/answers/detail/a_id/31777/c/17795/supporthub/complete-anatomy/';
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: supportHubLink });
    };
    const onRedeem = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield redeem();
        }
        catch (redeemError) {
            console.error(redeemError);
        }
    });
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'RedeemCodePageContentGrasshopper_Container', children: [(0, jsx_runtime_1.jsx)(StyledButton, { onClick: onClickSignOut, "data-e2e": 'RedeemCodePageContentGrasshopper_StyledButton', children: t(i18n_1.Strings.auth.signOut).toUpperCase() }), (0, jsx_runtime_1.jsxs)(Content, { "data-e2e": 'RedeemCodePageContentGrasshopper_Content', children: [(0, jsx_runtime_1.jsx)(StyledRedeemCodeImage, { "data-e2e": 'RedeemCodePageContentGrasshopper_StyledRedeemCodeImage' }), (0, jsx_runtime_1.jsx)(StyledTitle, { "data-e2e": 'RedeemCodePageContentGrasshopper_StyledTitle', children: t(i18n_1.Strings.userOnboarding.redeemCode.title) }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { "data-e2e": 'RedeemCodePageContentGrasshopper_StyledSubtitle', children: t(i18n_1.Strings.userOnboarding.redeemCode.subtitle) }), (0, jsx_runtime_1.jsx)(StyledRedeemCode, { onChange: onCodeChange, code: code, "data-e2e": 'RedeemCodePageContentGrasshopper_StyledRedeemCode' }), error && ((0, jsx_runtime_1.jsx)(ErrorMessage, { "data-e2e": 'RedeemCodePageContentGrasshopper_ErrorMessage', children: t(i18n_1.Strings.userOnboarding.redeemCode.error.common) })), (0, jsx_runtime_1.jsx)(StyledRedeemCodeButton, { disabled: !canRedeem || isLoading, onClick: onRedeem, "data-e2e": 'RedeemCodePageContentGrasshopper_StyledRedeemCodeButton', children: t(i18n_1.Strings.userOnboarding.redeemCode.submit) })] }), (0, jsx_runtime_1.jsxs)(Footer, { "data-e2e": 'RedeemCodePageContentGrasshopper_Footer', children: [t(i18n_1.Strings.userOnboarding.redeemCode.needAssistance.text), (0, jsx_runtime_1.jsx)(NeedHelpButton, { onClick: onNeedAssistanceClick, "data-e2e": 'RedeemCodePageContentGrasshopper_NeedHelpButton', children: t(i18n_1.Strings.userOnboarding.redeemCode.needAssistance.link) })] }), popover] }));
}
const RedeemCodePageContentWithPurchasesProvider = (0, purchases_1.withPurchasesProvider)(RedeemCodePageContentGrasshopper);
exports.RedeemCodePageContentGrasshopper = RedeemCodePageContentWithPurchasesProvider;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  position: absolute;
  top: 12px;
  right: 12px;
  color: ${({ theme }) => theme.designSystem.textSecondary};
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  &:hover {
    background-color: inherit;
  }
`;
const Container = styled_components_1.default.div `
  ${ui_1.deviceMainScreenLandscape.mobile `
      height: 100%;
  `}

  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.brandedBlack};
`;
const StyledRedeemCodeImage = (0, styled_components_1.default)(redeem_code_svg_1.default) `
  display: block;

  height: 140px;
  width: 140px;

  margin: 97.5px 0 20px;

  ${ui_1.deviceMainScreen.mobile `
    margin: 48px 0 20px;
  `}

  ${ui_1.deviceMainScreen.mobileS `
    display: none;
  `}

  ${ui_1.deviceMainScreenLandscape.tablet `
    display: none;
  `}
`;
const Content = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 48px 16px;
  align-items: center;
  min-height: 0;
  flex: 1;

  ${ui_1.deviceMainScreen.tablet `
    
    padding: 0;
    margin-top: 48px;

    flex: initial;
  `}
  ${ui_1.deviceMainScreenLandscape.tablet `
    padding-bottom: 0;
  `}
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  margin-bottom: 16px;
`;
const StyledSubtitle = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  margin-bottom: 28px;

  color: ${({ theme }) => theme.designSystem.textSecondary};

  ${ui_1.deviceMainScreen.mobileS `
    min-height: 61px;
    
    margin-bottom: 54px;
  `}
`;
const StyledRedeemCode = (0, styled_components_1.default)(RedeemCode_1.RedeemCode) `
  width: auto;
  padding: 24px;
`;
const ErrorMessage = styled_components_1.default.div `
  margin-top: 8px;

  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.designSystem.warning};
  text-align: center;
`;
const StyledRedeemCodeButton = (0, styled_components_1.default)(PrimaryButton_1.PrimaryButton) `
  margin-top: 10%;

  ${ui_1.deviceLandscape.mobileS `
    margin-bottom: 22px;
    margin-top: 0;
  `}

  ${ui_1.deviceMainScreen.mobileS `
    margin-bottom: 0;
        margin-top: 0;
  `}
`;
const Footer = styled_components_1.default.footer `
  position: absolute;
  display: block;

  bottom: 16px;
  left: 16px;

  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  margin-top: auto;
  padding: 18px 0 0;
  color: ${({ theme }) => theme.designSystem.textSecondary};
  font-size: 14px;
  line-height: 24px;

  ${ui_1.deviceMainScreenLandscape.mobile `
    position: relative;
    display: block;
    margin-left: -50%;
  `}
`;
const NeedHelpButton = styled_components_1.default.a `
  margin: 0 0 0 4px;
  padding: 0;

  border: none;
  background: none;

  text-decoration: underline;
  color: ${({ theme }) => theme.designSystem.accent};
  font-size: 14px;
  line-height: 24px;

  cursor: pointer;
`;
